import { Component, inject } from '@angular/core';
import { ToastService } from '@doc/api/server-bo';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'doc-toasts',
  templateUrl: './toasts.component.html',
  host: { class: 'toast-container position-fixed top-0 end-0 p-3', style: 'z-index: 1200' },
  standalone: true,
  imports: [NgbToastModule],
  styleUrls: ['./toasts.component.scss']
})
export class ToastsComponent {
readonly toastService = inject(ToastService);
}
